import { render, staticRenderFns } from "./PlusLinkEl.vue?vue&type=template&id=f573564c&scoped=true&"
import script from "./PlusLinkEl.vue?vue&type=script&lang=ts&"
export * from "./PlusLinkEl.vue?vue&type=script&lang=ts&"
import style0 from "./PlusLinkEl.vue?vue&type=style&index=0&id=f573564c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f573564c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VSheet})
